export const spmx = {
  translation: {
    "Belimo Energy Valve": "Energy Valve de Belimo",
    Yes: "Sí",
    No: "No",
    "You cannot go back from this position":
      "No se puede volver atrás de esta posición",
    Chapters: "Capítulos",
    Start: "Inicio",
    "Connecting to the Energy Valve":
      "Conexión a la Energy Valve",
    "Control Source": "Fuente de control",
    "Do you know the design flow rate?":
      "¿Conoce el caudal de diseño?",
    "Flow Control": "Control de flujo",
    "Is the building running off fixed or varying flow temperatures?":
      "¿El edificio funciona con temperaturas de flujo fijas o variables?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Temperaturas de flujo variables (Delta T Manager Scaling)",

    "Fixed flow temperatures (Delta T Manager)":
      "Temperaturas de flujo fijas (Delta T Manager)",
    "I am not sure": "No estoy seguro",
    "Delta T Manager": "Delta T Manager",
    Scaling: "Escalado",
    "Do you know the power output?":
      "¿Conoce la potencia de salida?",
    "Yes (Power Control)": "Sí (control de potencia)",
    "No (Position Control)": "No (control de posición)",
    "Power Control": "Control de potencia",
    "Position Control": "Control de posición",
    "Onboard Data Analysis": "Análisis de datos a bordo",
    "Did you get a clear result from the Energy Valve?":
      "¿Obtuvo un resultado claro de la válvula de energía?",
    "How do you want to setup your Energy Valve?":
      "¿Cómo quieres configurar tu Energy Valve?",
    "Would you like to connect to the cloud?":
      "¿Quieres conectarte a la nube?",
    "Cloud Connectivity": "Conectividad a la nube",
    "Onboard Diagnostics / Download Data":
      "Diagnóstico a bordo / Descarga de datos",
    "Download Data": "Descargar datos",
    "Send optimization request":
      "Enviar solicitud de optimización",
    End: "Fin",

    Subtitles: "Subtítulos",
    Repeat: "Repita",
    Continue: "Continuar",
  },
};
